import { useParams } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'

function App({ setCompletionMessage, setIsDkabio }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  // const [showShareBtn, setShowShareBtn] = useState(true)
  // let { pid } = useParams()
  // pid = 'P' + pid.split('p')[1]
  // 特殊設定

  // console.log('pathname', pathname)
  // const pid = 'P240703185556'
  const { pid, access_token, member_mission_id } = useParams()
  // console.log(
  //   'pid, access_token, member_mission_id',
  //   pid,
  //   access_token,
  //   member_mission_id
  // )
  // const [haUserId, setHaUserId] = useState('')
  // const { user_id: routeUserId } = useParams()

  // useEffect(() => {
  //   if (routeUserId !== undefined) {
  //     setHaUserId(routeUserId)
  //   }
  // }, [])

  // console.log('user_id', user_id)
  // console.log('access_id', access_id)
  // console.log('member_mission_id', member_mission_id)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        // haUserId={user_id}
        haAccessToken={access_token}
        haMemberMissionId={member_mission_id}
        setCompletionMessage={setCompletionMessage}
        setIsDkabio={setIsDkabio}
      />
    </>
  )
}

export default App
